import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "label", "validation", "icon", "inputComponent"];
import "core-js/modules/es6.array.map.js";
// TODO: remove this component in Currency v3
// NOTE: given the impending removal of this component, it will not be
// converted to TypeScript.
import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { InputGroup } from '../InputGroup/InputGroup';
import { Input } from './Input';
export var getErrorFromValidation = function getErrorFromValidation(validation) {
  return validation && validation.isValid === false;
};
export var getHelpFromValidation = function getHelpFromValidation(validation) {
  var error = getErrorFromValidation(validation);

  if (error && Array.isArray(validation.feedback)) {
    return /*#__PURE__*/React.createElement("span", null, validation.feedback.map(function (feedback, index) {
      return /*#__PURE__*/React.createElement("span", {
        // eslint-disable-next-line react/no-array-index-key
        key: "validation-feedback-".concat(index),
        className: classes('display-block') // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: feedback
        }
      });
    }));
  }

  return null;
};
/**
 * This component provides the same API as the <Input> component before v9.
 * It's meant as a backwards-compatibility "shim" to make upgrading easier.
 *
 * This is a combination of Input and InputGroup. You should eventually
 * migrate to using Input and InputGroup separately yourself.
 */

export var LegacyInput = function LegacyInput(_ref) {
  var id = _ref.id,
      label = _ref.label,
      validation = _ref.validation,
      icon = _ref.icon,
      inputComponent = _ref.inputComponent,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var InputComponent = inputComponent;
  return /*#__PURE__*/React.createElement(InputGroup, {
    label: label,
    error: getErrorFromValidation(validation),
    help: getHelpFromValidation(validation),
    inputId: id,
    input: /*#__PURE__*/React.createElement(InputComponent, _extends({
      id: id,
      icon: icon,
      error: getErrorFromValidation(validation),
      fullWidth: true
    }, otherProps))
  });
};
LegacyInput.defaultProps = {
  inputComponent: Input
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  LegacyInput.propTypes = {
    placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.node,
    id: PropTypes.string,

    /*
     * validation object has the following structure:
     *   isValid: true/false based on if there is an error state
     *   errors: array of error strings, separate from error display messages
     *   feedback: array of error strings, which are intended to be displayed to the user.
     *     HTML can be passed in, so a valid error string is "Please enter a <b>number</b>"
     */
    validation: PropTypes.object,
    // eslint-disable-line react/forbid-prop-types
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    type: PropTypes.string,
    pattern: PropTypes.string,
    className: PropTypes.string,
    maxLength: PropTypes.number,
    icon: PropTypes.node,
    inputComponent: PropTypes.any // eslint-disable-line react/forbid-prop-types

    /**
     * Any further props will be passed to the <Input> component.
     */

  };
}

export { // Backwards compatibility, remove in next semver-major
getHelpFromValidation as getFeedbackFromValidation };